import { useSelector } from "react-redux";

import {
  businessFinanceIconsSet,
  capitalFinanceIconsSet,
  assetBasedIconsSet,
  businessFinanceIslamicIconsSet,
  capitalFinanceIslamicIconsSet,
  assetBasedIslamicIconsSet
} from "./constants";
import { financeNames } from "../../constants";
import { getFinanceType, getIsIslamicBanking } from "../../store/selectors/appConfig";

export const useIconsByFinance = () => {
  const financeType = useSelector(getFinanceType);
  const isIslamicBanking = useSelector(getIsIslamicBanking);

  if (financeType === financeNames.businessFinance) {
    return isIslamicBanking ? businessFinanceIslamicIconsSet : businessFinanceIconsSet;
  } else if (financeType === financeNames.capitalFinance) {
    return isIslamicBanking ? capitalFinanceIslamicIconsSet : capitalFinanceIconsSet;
  } else if (financeType === financeNames.assetBasedFinance) {
    return isIslamicBanking ? assetBasedIslamicIconsSet : assetBasedIconsSet;
  }

  return assetBasedIconsSet;
};
